/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "../../../../Helper/Pagination";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { showErrorAlert } from "../../../../Helper/SweetAlert";
import { format } from "date-fns";
import { MoonLoader } from "react-spinners";

export default function AffiliateUser() {
  const [userData, setUserData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [userLimit] = useState(10);

  const [sorting] = useState("createdAt|desc");
  const [search, setSearch] = useState("");

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    getUserList();
  }, [search, currentPage, status]);

  const getUserList = async () => {
    setLoading(true);

    const data = {
      limit: userLimit,
      sorting: sorting,
      page: currentPage,
      search_key: search,
      status: status,
    };

    GetService(API_URL.GET_ALL_AFFILIATE_USERS, {
      params: data,
    }).then(
      (res) => {
        console.log("Affiliate users:", res);

        if (res?.data?.status === true) {
          setUserData(res?.data?.data?.item || []);
          setTotalPages(res?.data?.data?.totalPages || 0);
          setTotal(res?.data?.data?.totalItems || 0);
        } else {
          setUserData([]);
          setTotalPages(0);
          setTotal(0);

          showErrorAlert(res?.data?.message || "Failed to get affiliate users");
        }

        setLoading(false);
      },
      (err) => {
        console.error(err);

        showErrorAlert(err?.data?.message || "Something went wrong");

        setLoading(false);
      },
    );
  };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "approved":
        return <span className="badge bg-success">Approved</span>;

      case "rejected":
        return <span className="badge bg-danger">Rejected</span>;

      case "pending":
      default:
        return <span className="badge bg-warning text-dark">Pending</span>;
    }
  };

  return (
    <>
      {/* Header */}
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Affiliate Users</h3>
            </div>

            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>

                <Link
                  className="breadcrumb-item active"
                  style={{ textDecoration: "none" }}
                >
                  Affiliate Users
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  {/* Filters */}
                  <div className="row px-3">
                    <div className="col-md-3 p-0">
                      <select
                        className="form-control"
                        value={status}
                        onChange={(e) => {
                          setStatus(e.target.value);
                          setCurrentPage(0);
                        }}
                      >
                        <option value="">All Status</option>

                        <option value="pending">Pending</option>

                        <option value="approved">Approved</option>

                        <option value="rejected">Rejected</option>
                      </select>
                    </div>

                    <div className="col-md-4 offset-md-5 p-0">
                      <input
                        type="text"
                        placeholder="Search by Keyword"
                        className="form-control"
                        autoComplete="off"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setCurrentPage(0);
                        }}
                      />
                    </div>
                  </div>

                  {/* Table */}
                  <div className="table-responsive mt-4">
                    {!loading && (
                      <table className="table table-hover table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Full Name</th>
                            <th>Email</th>
                            <th>Mo. No.</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {userData?.map((item, i) => (
                            <tr key={item?.id || item?._id || i}>
                              <td>{i + currentPage * userLimit + 1}</td>

                              <td>
                                {item?.firstName || item?.lastName
                                  ? `${item?.firstName || ""} ${item?.lastName || ""}`
                                  : item?.fullName || "N/A"}
                              </td>

                              <td>{item?.email || "-"}</td>

                              <td>{item?.phone || "-"}</td>

                              <td>{item?.affiliateType || "-"}</td>

                              <td>{getStatusBadge(item?.status)}</td>

                              <td>
                                {item?.createdAt
                                  ? format(
                                      new Date(item.createdAt),
                                      "dd/MM/yyyy",
                                    )
                                  : "N/A"}
                              </td>

                              <td>
                                <span
                                  title="View"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  className="mx-2"
                                  onClick={() => {
                                    navigate(
                                      `details/${item?.id || item?._id}`,
                                    );
                                  }}
                                >
                                  <i className="text-warning fas fa-eye"></i>
                                </span>
                              </td>
                            </tr>
                          ))}

                          {userData?.length === 0 && (
                            <tr>
                              <td colSpan="8" className="text-center">
                                <h6 className="p-3">No Data Found</h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}

                    {/* Loader */}
                    {loading && (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />

                        <div>Loading... Please wait.</div>
                      </div>
                    )}

                    {/* Pagination */}
                    <div className="mt-4">
                      <Pagination
                        counting={currentPage * userLimit}
                        totaldata={total}
                        pagecount={totalPages}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
